const quiz = () => {
    const inputLocation = document.querySelector('.constructor__location--location');
    const inputEmail = document.querySelector('.constructor__location--email');
    const LOCATION_REGEXP = /[a-zA-Zа-яА-я]/g;
    const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
    const firstStepBtn = document.querySelector('.constructor__button');

    const validLocation = (value) => {
        return (LOCATION_REGEXP.test(value) && value.length > 3);
    }

    const validEmail = (value) => {
        return (EMAIL_REGEXP.test(value) && value.length > 7);
    }

    function validate(nameOfInput, validTest) {
        
        function onInput() {
            if(validTest(nameOfInput.value)) {
                nameOfInput.classList.remove('constructor__location--error');
            } else {
                nameOfInput.classList.add('constructor__location--error')
            }
        }
        nameOfInput.addEventListener('change', onInput);
    }
    validate(inputLocation, validLocation);
    validate(inputEmail, validEmail);


    function choiseRoomType () {
        const types = document.querySelectorAll('.constructor__first-stage .constructor__item');
        types.forEach((type, i) => {
            type.addEventListener('click', () => {
                types.forEach(item => {
                    item.classList.remove('active');
                })
                types[i].classList.add('active')
            })
        })
    }
    choiseRoomType()

    function mooveRange() {
        const slider = document.querySelector('.constructor__range');
        const stripe = document.querySelector('.constructor__stripe');
        let mm = gsap.matchMedia();
        mm.add({
        isMobile: "(max-width: 576px)",
        isDesktop: "(min-width: 577px)"
        }, (context) => {
        let { isMobile, isDesktop } = context.conditions;
            slider.addEventListener('input', () => {
                let output = document.querySelector('#volume');
                    stripe.style.width = (slider.value / 500) * 100 + 1 + "%";
                    
                if (slider.value <= 55) {
                    
                    output.style.left = isDesktop ? ( (slider.value / 500) * 100 + 5 + "%") : ((slider.value / 500) * 100 + 10 + "%");
                    output.value = '< 1 mW'
                } else if (55 < slider.value && slider.value <= 100) {
                    output.style.left = isDesktop ? ((slider.value / 500) * 100 - 5 + "%") :  ((slider.value / 500) * 100 + 10 + "%");
                    output.value = '< 1 mW'
                
                } else if (100 < slider.value && slider.value <= 200) {
                    
                    output.style.left = isDesktop ? ((slider.value / 500) * 100 - 5 + "%") :  ((slider.value / 500) * 100 - 10 + "%");
                    output.value = '1 mW—5 mW'
                } else if (200 < slider.value && slider.value <= 300) {
                    
                    output.style.left = isDesktop ? ((slider.value / 500) * 100 - 7  + "%") :  ((slider.value / 500) * 100 - 10 + "%");
                    output.value = '5 mW—10 mW'
                } else if (300 < slider.value && slider.value <= 400) {
                    
                    output.style.left = isDesktop ? ((slider.value / 500) * 100 - 7  + "%"):  ((slider.value / 500) * 100 - 10 + "%");
                    output.value = '10 mW—50 mW'
                } else if (400 < slider.value && slider.value <= 450) {
                    
                    output.style.left = isDesktop ? ((slider.value / 500) * 100 - 7  + "%") :  ((slider.value / 500) * 100 - 20 + "%");
                    output.value = '50 mW—100 mW'
                } else if (slider.value > 450) {
                    
                    output.style.left = isDesktop ? ((slider.value / 500) * 100 - 20  + "%") :  ((slider.value / 500) * 100 - 35 + "%");
                    output.value = '> 100 mW'
                }
            })

        })

      
    }
    mooveRange();

    const containerFirst = document.querySelector('.constructor__first-stage');
    const containerSecond = document.querySelector('.constructor__second-stage');
    const containerThird = document.querySelector('.constructor__third-stage');
    const containerFouth = document.querySelector('.constructor__fouth-stage');
    const responceBlock = document.querySelector('.constructor__responce');
    const num = document.querySelector('.constructor__numbers div:first-child');
    const tlNumbers = gsap.timeline({
        duration: 2.5
    })
    function firstData() {
        tlNumbers.to('.constructor__numbers div:nth-child(1)', {borderColor: '#b4141e'})

        const firstBtn = document.querySelector('.constructor__first-stage .constructor__button');

        firstBtn.addEventListener('click', () => {
           

            const locationInputValue = document.querySelector('.constructor__location--location').value;
            const emailInputValue = document.querySelector('.constructor__location--email').value;
            const capacityValue  = document.querySelector('.constructor__ratio').value;
            const roomTypeValue = document.querySelector('.constructor__first-stage .constructor__item.active span').innerText;

            if(validLocation(locationInputValue) && validEmail(emailInputValue)) {
                localStorage.setItem('location', locationInputValue);
                localStorage.setItem('capacity', capacityValue);
                localStorage.setItem('roomType', roomTypeValue);
                localStorage.setItem('email', emailInputValue);

                gsap.to(containerFirst, {
                    height: 0,
                    autoAlpha: 1,
                    duration: .3,
                    ease: 'power1.out'
                })

                gsap.to(containerSecond, {
                    height: 'auto',
                    autoAlpha: 1,
                    duration: .3,
                    ease: 'power1.out'
                })

                
                tlNumbers.to('.constructor__numbers div:nth-child(2)', {backgroundColor: '#b4141e'}, '<')
                .to('.constructor__numbers div:nth-child(3)', {borderColor: '#b4141e'})
                gsap.to(window, { duration: .5, scrollTo: ".constructor" });
                if (window.innerWidth <= 576) {
                    num.textContent = 'II';
                }
            } else if(validLocation(locationInputValue) && !validEmail(emailInputValue)) {
                inputEmail.classList.add('constructor__location--error');

            } else if(!validLocation(locationInputValue) && validEmail(emailInputValue)) {
                inputLocation.classList.add('constructor__location--error');

            } else {
                inputLocation.classList.add('constructor__location--error');
                inputEmail.classList.add('constructor__location--error');
            }
        })
    }
    firstData();

    function secondData() {
        const backButton = document.querySelector('.constructor__second-stage .constructor__btn.back');
        backButton.addEventListener('click', () => {
            gsap.to(containerSecond, {
                height: 0,
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })

            gsap.to(containerFirst, {
                height: 'auto',
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })
            gsap.to(window, { duration: .5, scrollTo: ".constructor" });

            tlNumbers.to('.constructor__numbers div:nth-child(3)', {borderColor: '#ffffff'}, '<')
            .to('.constructor__numbers div:nth-child(2)', {backgroundColor: '#ffffff'})

            if (window.innerWidth <= 576) {
                num.textContent = 'I';
            }
        })

        const farms = document.querySelectorAll('.constructor__farm');
        const inputs = document.querySelectorAll('.constructor__farm input');

        farms.forEach((farm, i) => {
            farm.addEventListener('click', ()=> {
                farms.forEach(item => {
                    item.classList.remove('active')
                });
                inputs.forEach(item => {
                    item.removeAttribute('checked', '');
                })

                farms[i].classList.add('active')
                inputs[i].setAttribute('checked', '');
            })
        });

        const nextBtn = document.querySelector('.constructor__second-stage .constructor__btn.next');

        nextBtn.addEventListener('click', () => {
            const equimentValue = document.querySelector('.constructor__farm.active label').innerText;

            localStorage.setItem('equiment', equimentValue);

            gsap.to(containerSecond, {
                height: 0,
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })

            gsap.to(containerThird, {
                height: 'auto',
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })
            gsap.to(window, { duration: .5, scrollTo: ".constructor" });
            if (window.innerWidth <= 576) {
                num.textContent = 'III';
            }

            tlNumbers.to('.constructor__numbers div:nth-child(4)', {backgroundColor: '#b4141e'}, '<')
            .to('.constructor__numbers div:nth-child(5)', {borderColor: '#b4141e'});
        })
    }
    secondData();

    function thirdData() {
        const backBtn = document.querySelector('.constructor__third-stage .constructor__btn.back');

        backBtn.addEventListener('click', () => {
            gsap.to(containerThird, {
                height: 0,
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })

            gsap.to(containerSecond, {
                height: 'auto',
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })
            gsap.to(window, { duration: .5, scrollTo: ".constructor" });

            if (window.innerWidth <= 576) {
                num.textContent = 'II';
            }

            tlNumbers.to('.constructor__numbers div:nth-child(5)', {borderColor: '#ffffff'}, '<')
            .to('.constructor__numbers div:nth-child(4)', {backgroundColor: '#ffffff'});
        });

        const selections = document.querySelectorAll('.constructor__third-stage .constructor__item');

        selections.forEach((selection, i) => {
            selection.addEventListener('click', () => {
                selections.forEach(selection => {
                    selection.classList.remove('active')
                })
            selections[i].classList.add('active');

            })
        })

        const checks = document.querySelectorAll('.constructor__check');
        const inputChecks = document.querySelectorAll('.constructor__check input')

        checks.forEach((check, i) => {
            check.addEventListener('click', () => {
                check.classList.toggle('active')
                check.classList.contains('active') ? inputChecks[i].setAttribute('data-checked', 'yes') : inputChecks[i].setAttribute('data-checked', 'no')
            })
        })

        const nextBtn = document.querySelector('.constructor__third-stage .constructor__btn.next');

        nextBtn.addEventListener('click', () => {
            const coolingValue = document.querySelector('.constructor__third-stage .constructor__item.active span').innerText;
            const householdValue = document.querySelector('input[name="household"]').getAttribute('data-checked');
            const staffValue = document.querySelector('input[name="staff"]').getAttribute('data-checked');

            localStorage.setItem('cooling', coolingValue);
            localStorage.setItem('household', householdValue);
            localStorage.setItem('staff', staffValue);

            gsap.to(containerThird, {
                height: 0,
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })

            gsap.to(containerFouth, {
                height: 'auto',
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })
            gsap.to(window, { duration: .5, scrollTo: ".constructor" });

            const location = document.querySelector('.location');
            const email = document.querySelector('.email');
            const capacity = document.querySelector('.capacity');
            const room = document.querySelector('.room');
            const equipment = document.querySelector('.equipment');
            const cooling = document.querySelector('.cooling');
            const household = document.querySelector('.household');
            const staff = document.querySelector('.staff');
    
            location.value = localStorage.getItem('location');
            email.value = localStorage.getItem('email');
            capacity.value = localStorage.getItem('capacity');
            room.value = localStorage.getItem('roomType');
            equipment.value = localStorage.getItem('equiment');
            cooling.value = localStorage.getItem('cooling');
            household.value = localStorage.getItem('household');
            staff.value = localStorage.getItem('staff');

        })
    }

    thirdData();

    function fouthData() {
        const backBtn = document.querySelector('.constructor__fouth-stage .constructor__btn.back');
        const nextBtn = document.querySelector('.constructor__fouth-stage .constructor__btn.next');

        backBtn.addEventListener('click', () => {
            gsap.to(containerFouth, {
                height: 0,
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })

            gsap.to(containerThird, {
                height: 'auto',
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })
            gsap.to(window, { duration: .5, scrollTo: ".constructor" });
        });
        nextBtn.addEventListener("click", (event) => {
            let form = document.querySelector('#quiz');
            const responceBlock = document.querySelector('.constructor__responce');
            form.addEventListener('submit', async function (event) {
                event.preventDefault();

                let response = await fetch("/mailer/mail-quiz.php", {
                    method: "POST",
                    body: new FormData(form),
                });
        
                if (response.ok) {
                    console.log('jo');
                    gsap.to(containerFouth, {
                        height: 0,
                        autoAlpha: 1,
                        duration: .3,
                        ease: 'power1.out'
                    })
        
                    gsap.to(responceBlock, {
                        height: 'auto',
                        autoAlpha: 1,
                        duration: .3,
                        ease: 'power1.out'
                    })
                    gsap.to(window, { duration: .5, scrollTo: ".constructor" });
                } else {
                    console.log('fail')
                    gsap.to(containerFouth, {
                        height: 0,
                        autoAlpha: 1,
                        duration: .3,
                        ease: 'power1.out'
                    })
        
                    gsap.to(responceBlock, {
                        height: 'auto',
                        autoAlpha: 1,
                        duration: .3,
                        ease: 'power1.out'
                    })
                    gsap.to(window, { duration: .5, scrollTo: ".constructor" });
                }
            })
        })
    }

    fouthData();

    function sendAgain() {
        const againBtn = document.querySelector('.again');
        againBtn.addEventListener('click', () => {
            document.querySelector('.constructor__location--location').value='';
            document.querySelector('.constructor__location--email').value='';
            gsap.to(responceBlock, {
                height: 0,
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })

            gsap.to(containerFirst, {
                height: 'auto',
                autoAlpha: 1,
                duration: .3,
                ease: 'power1.out'
            })
            gsap.to(window, { duration: .5, scrollTo: ".constructor" });

            tlNumbers.to('.constructor__numbers div:nth-child(5)', {borderColor: '#ffffff'}, '<')
            .to('.constructor__numbers div:nth-child(4)', {backgroundColor: '#ffffff'}, '<')
            .to('.constructor__numbers div:nth-child(3)', {borderColor: '#ffffff'}, '<')
            .to('.constructor__numbers div:nth-child(2)', {backgroundColor: '#ffffff'});
        })

    }
    sendAgain();
}

module.exports = quiz;